import React, { useEffect, useState } from "react"
import { sitename } from "../../constants/constants"
import { withRouter } from "react-router-dom"
import { FiltersCard } from "components/Common/FiltersCard"
import { getSummaryData } from "helpers/repository"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  CardHeader,
  Collapse,
} from "reactstrap"
import TableLoader from "../../components/Common/TableLoader"
import Summary from "./summarydata/Summary"
import SportsData from "./summarydata/SportsData"
import PragmaticData from "./summarydata/PragmaticData"
import TurboData from "./summarydata/TurboData"
import SpribeData from "./summarydata/SpribeData"
import { hasPermission } from "helpers/helpers"
import Bigwins from "./summarydata/Bigwins"

const Welcome = props => {
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [summary, setsummary] = useState([])
  const [sports, setsports] = useState([])
  const [pragmatic, setpragmatic] = useState([])
  const [turbo, setturbo] = useState([])
  const [spribe, setspribe] = useState([])
  const [bigwins, setbigwins] = useState([])

  const call = () => {
    setsummary([])
    setsports([])
    setpragmatic([])
    setturbo([])
    setspribe([])
    setbigwins([])
    const payload = {
      from: fromDate,
      to: toDate,
    }
    getSummaryData(primaryCallback, error, payload)
  }
  useEffect(() => {
    call()
  }, [])

  const primaryCallback = res => {
    setsummary(res.data.summary)
    setsports(res.data.sports)
    setpragmatic(res.data.pragmatic)
    setturbo(res.data.turbo)
    setspribe(res.data.spribe)
    setbigwins(res.data.bigwins)
  }
  const error = err => {
    console.log(err)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/*<DateRangeCard />*/}
          <Card>
            <CardBody>
              <h3>Welcome {sitename}</h3>
            </CardBody>
          </Card>
          {hasPermission("access-summary") && (
            <div>
              <FiltersCard
                fromDate={fromDate}
                toDate={toDate}
                setToDate={setToDate}
                setFromDate={setFromDate}
                showToDate={true}
                call={() => {
                  call()
                }}
                notDisplayFilter={true}
                hideShowType={false}
              />
              {summary.length === 0 ? (
                <TableLoader />
              ) : (
                <div>
                  <Summary data={summary} />
                  <SportsData data={sports} />
                  <PragmaticData data={pragmatic} />
                  <TurboData data={turbo} />
                  <SpribeData data={spribe} />
                  <Bigwins data={bigwins} />
                </div>
              )}
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}
export default withRouter(Welcome)
